import {Navigate, useLocation} from "react-router-dom";
import {verifyToken} from "../services/misc.service.js";
import {useEffect, useState} from "react";

export const roleRedirects = {
	sklad_rahbari: "/balance",
	seh_brigadir: "/invoice-creation",
	security: "/release",
	admin: "/balance",
};

export const DefaultRedirect = () => {
	const userRole = sessionStorage.getItem("role");
	return <Navigate to={roleRedirects[userRole] || "/login"} replace />;
};

const ProtectedRoute = ({children, allowedRoles}) => {
	const [isValid, setIsValid] = useState(null);
	const [redirect, setRedirect] = useState(false);

	const token = sessionStorage.getItem("token");
	const userRole = sessionStorage.getItem("role");
	const location = useLocation();

	useEffect(() => {
		const checkToken = async () => {
			try {
				const response = await verifyToken(token);

				if (response.valid) {
					if (
						response.user.role[0].name !== `sklad_rahbari` &&
						response.user.role[0].name !== `security`
					) {
						sessionStorage.setItem("sehId", response.user.seh[0].id);
					}
					sessionStorage.setItem("role", response.user.role[0].name);
					setIsValid(true);
				} else {
					setRedirect(true);
				}
			} catch (error) {
				console.error("Token is invalid or expired");
				sessionStorage.removeItem("token");
				setRedirect(true);
			}
		};

		if (token) {
			checkToken();
		} else {
			setRedirect(true);
		}
	}, [token]);

	if (isValid === null && !redirect) return <div>Loading...</div>;

	if (redirect) return <Navigate to="/login" replace />;

	if (!allowedRoles.includes(userRole)) {
		return (
			<Navigate
				to={roleRedirects[userRole] || "/"}
				state={{from: location}}
				replace
			/>
		);
	}

	return children;
};

export default ProtectedRoute;
